import Marquee from "react-fast-marquee";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 mt-24">
    <div className="py-10 border-b border-white/10 overflow-hidden">
      <Marquee speed={25} gradient={false} direction="right">
        {Array.from({ length: 6 }).map((_, i) => (
          <span key={i} className="font-display text-6xl sm:text-7xl mx-8 whitespace-nowrap">
            <span className="text-outline">COME HOME LIGER</span>
            <span className="text-[#4ADE80] mx-8">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-6 sm:px-10 py-8">
      <div className="font-display text-2xl text-white tracking-wide">
        MCNEWS<span className="text-[#4ADE80]">24</span>
      </div>
      <p className="font-mono-news text-[10px] sm:text-xs text-zinc-500 uppercase tracking-widest max-w-lg">
        A satirical fan publication. No cabins were harmed in the making of this article. Electricity siphoning is not an endorsed survival strategy.
      </p>
      <span className="font-mono-news text-[10px] text-zinc-600 uppercase tracking-widest">© 2026 MCNews24</span>
    </div>
  </footer>
);
